
import { computed, defineComponent } from '@nuxtjs/composition-api'
import { useFeatureFlag } from '~/composables/featureFlags/useFeatureFlag'
import { FeatureDefinitions } from '~/features/features'

export default defineComponent({
  props: {
    name: {
      type: String as () => keyof FeatureDefinitions,
      required: true,
    },
    expectedValue: {
      type: null,
      required: false,
      default: () => undefined,
    },
  },
  setup(props, ctx) {
    const flagValue = useFeatureFlag(props.name)
    const showFeature = computed(() => props.expectedValue === undefined || flagValue.value === props.expectedValue)

    return () => (showFeature.value ? ctx.slots.default && ctx.slots.default() : null)
  },
})
